import { render, staticRenderFns } from "./AdminFaqs.vue?vue&type=template&id=7a5d5718&"
import script from "./AdminFaqs.vue?vue&type=script&lang=js&"
export * from "./AdminFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports